import { DatePipe } from '@angular/common';
import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { CompanyAttributeDTO, CompanyProductSelectionAttributeWithOverrideInformation } from '@iota/iota-management-portal-v4-client';
import { AttributeValueDirective } from './attribute-value.directive';

export declare interface AttributeDetailsInterface {
    initAttribute(valueAttribute: CompanyAttributeDTO | CompanyProductSelectionAttributeWithOverrideInformation): void;
    markForDelete(): void;
    getUpsertedAttribute(): CompanyAttributeDTO | CompanyProductSelectionAttributeWithOverrideInformation | undefined;
}

@Directive({
    standalone: false,
    selector: '[appAttributeDetails]'
})
export class AttributeDetailsDirective extends AttributeValueDirective {
    // Previous and current attribute for comparison
    // Previous attribute is set if the attribute exists already
    // Current attribute is set if the attribute exists already or the attribute was imported
    @Input() previousAttribute: CompanyAttributeDTO | CompanyProductSelectionAttributeWithOverrideInformation;
    @Input() currentAttribute: CompanyAttributeDTO | CompanyProductSelectionAttributeWithOverrideInformation;

    @Input() parentId: string;
    @Input() locales: string[];
    @Input() editMode = false;
    @Input() hideTitleAndValueType = false;

    @Output() removeAttribute = new EventEmitter<void>();
    // Emitter for changing the badge-counter for upserted and deleted attributes

    @Output() updateMarkForDeleteValue = new EventEmitter<number>();
    @Output() updateMarkForUpsertValue = new EventEmitter<number>();

    @Input() markIfParentIdIsThisParentId = false;
    @Input() overridesOtherAttributeTooltip: string;
    @Input() parentIdIsThisParentIdTooltip: string;
    showEntitySpecificTooltip = false;

    markedForUpsert = false;
    markedForDelete = false;

    constructor(datePipe: DatePipe) {
        super(datePipe);
    }

    undoMarkForDelete() {
        this.markedForDelete = false;
        this.updateMarkForDeleteValue.emit(-1);
        if (this.markedForUpsert) this.updateMarkForUpsertValue.emit(1);
    }

    getDeletedAttributeId(): string | undefined {
        if (this.markedForDelete) {
            return this.previousAttribute?.attributeId;
        }

        return undefined;
    }

    isAttributeWithOverrideInformation(
        attribute: typeof this.currentAttribute
    ): attribute is CompanyProductSelectionAttributeWithOverrideInformation {
        if (!attribute) return false;

        return 'overwritten' in attribute;
    }

    clearAttributeAuditFieldsAndIds(attribute: CompanyAttributeDTO | CompanyProductSelectionAttributeWithOverrideInformation) {
        attribute.modificationBy = undefined;
        attribute.modificationDateTime = undefined;
        attribute.modificationById = undefined;
        attribute.creationBy = undefined;
        attribute.creationDateTime = undefined;
        attribute.creationById = undefined;

        attribute.skId = undefined;
        attribute.attributeId = undefined;
        attribute.validFrom = undefined;
        attribute.validTo = undefined;
    }
}
